import {useEffect, useState} from "react"
import {paymentArrangementAPI} from "@indebted/api/paymentArrangementAPI"
import {LoadingPage} from "@indebted/components/Loading"
import {ErrorPage} from "@indebted/components/Error"
import {useLocation, useNavigate} from "react-router-dom"

import {nextPage} from "../Navigator"
import {usePaymentArrangementId} from "../usePaymentArrangementId"

function Status() {
	const paymentArrangementID = usePaymentArrangementId()
	const location = useLocation()
	const i18n = location?.state?.I18n
	const [Component, setComponent] = useState(<LoadingPage I18n={i18n} />)
	const navigate = useNavigate()

	useEffect(() => {
		paymentArrangementAPI
			.pollConfirmation(paymentArrangementID)
			.then((result) => {
				navigate(nextPage(result.Next, paymentArrangementID))
			})
			.catch((error) => {
				setComponent(<ErrorPage error={error} />)
			})
	}, [navigate, paymentArrangementID])

	return <div data-testid="payment-arrangement-status">{Component}</div>
}

export {Status}
